export type FugaContributorRole =
  | "A&R Manager"
  | "A&R Administrator"
  | "Actor"
  | "Adapter"
  | "Agent"
  | "Arranger"
  | "Art Direction"
  | "Artist Management"
  | "Assistant Composer"
  | "Assistant Conductor"
  | "Assistant Director"
  | "Assistant Mastering Engineer"
  | "Assistant Mixing Engineer"
  | "Assistant Producer"
  | "Assistant Recording Engineer"
  | "Assistant Sound Engineer"
  | "Author"
  | "Band"
  | "Camera Operator"
  | "Choir"
  | "Choir Conductor"
  | "Choreographer"
  | "Chorus"
  | "Chorus Master"
  | "Cinemaphotographer"
  | "Co-Producer"
  | "Composer"
  | "Computer Graphic Creator"
  | "Conductor"
  | "Contributing Artist"
  | "Costume Designer"
  | "Creative Director"
  | "Dancer"
  | "Director"
  | "DJ"
  | "Editor"
  | "Engineer"
  | "Ensemble"
  | "Executive Producer"
  | "Featuring"
  | "Gaffer"
  | "Guest Vocals"
  | "Immersive Mixing Engineer"
  | "Key Grip"
  | "Librettist"
  | "Lighting Director"
  | "Liner Notes"
  | "Lyricist"
  | "Mastering Engineer"
  | "MC"
  | "Mixer"
  | "Mixing Engineer"
  | "Musical Director"
  | "Narrator"
  | "Orchestra"
  | "Orchestrator"
  | "Performer"
  | "Playwright"
  | "Post-Producer"
  | "Producer"
  | "Production Assistant"
  | "Programmer"
  | "Recording Engineer"
  | "Remixer"
  | "Set Designer"
  | "Soloist"
  | "Sound Editor"
  | "Sound Engineer"
  | "Spoken Word"
  | "Strings Conductor"
  | "Studio Personnel"
  | "Tonmeister"
  | "Translator"
  | "Video Director"
  | "Video Producer"
  | "Visual Effects Technician"
  | "Writer";

export const FUGA_CONTRIBUTOR_ROLE: FugaContributorRole[] = [
  "A&R Manager",
  "A&R Administrator",
  "Actor",
  "Adapter",
  "Agent",
  "Arranger",
  "Art Direction",
  "Artist Management",
  "Assistant Composer",
  "Assistant Conductor",
  "Assistant Director",
  "Assistant Mastering Engineer",
  "Assistant Mixing Engineer",
  "Assistant Producer",
  "Assistant Recording Engineer",
  "Assistant Sound Engineer",
  "Author",
  "Band",
  "Camera Operator",
  "Choir",
  "Choir Conductor",
  "Choreographer",
  "Chorus",
  "Chorus Master",
  "Cinemaphotographer",
  "Co-Producer",
  "Composer",
  "Computer Graphic Creator",
  "Conductor",
  "Contributing Artist",
  "Costume Designer",
  "Creative Director",
  "Dancer",
  "Director",
  "DJ",
  "Editor",
  "Engineer",
  "Ensemble",
  "Executive Producer",
  "Featuring",
  "Gaffer",
  "Guest Vocals",
  "Immersive Mixing Engineer",
  "Key Grip",
  "Librettist",
  "Lighting Director",
  "Liner Notes",
  "Lyricist",
  "Mastering Engineer",
  "MC",
  "Mixer",
  "Mixing Engineer",
  "Musical Director",
  "Narrator",
  "Orchestra",
  "Orchestrator",
  "Performer",
  "Playwright",
  "Post-Producer",
  "Producer",
  "Production Assistant",
  "Programmer",
  "Recording Engineer",
  "Remixer",
  "Set Designer",
  "Soloist",
  "Sound Editor",
  "Sound Engineer",
  "Spoken Word",
  "Strings Conductor",
  "Studio Personnel",
  "Tonmeister",
  "Translator",
  "Video Director",
  "Video Producer",
  "Visual Effects Technician",
  "Writer",
];
